import { useEffect, useContext } from 'react'
import { Table } from "freespace-react-components";
import HealthOverviewContext from '../../context/HealthOverviewContext';
import { useLocation } from 'react-router-dom';

const LocationWiseHealth = () => {
    const { devicesInfo, setProductType } = useContext<any>(HealthOverviewContext);
    // console.table(devicesInfo);


    const dataFromPage = useLocation();
    // console.log(dataFromPage);



    useEffect(() => {
        if (dataFromPage.state.ProductType === 'FLO') {
            setProductType(['FLO', 'POE FLO']);
        } else if (dataFromPage.state.ProductType === 'TIM') {
            setProductType(['TIM', 'POE TIM']);
        } else if (dataFromPage.state.ProductType === 'TIM+') {
            setProductType(['TIM+', 'POE TIM+']);
        } else {
            setProductType([dataFromPage.state.ProductType])
        }
    }, [setProductType]);


    const tagConditions = [
        {
            key: 'TOy',
            condition: (value) => value > 0 ? 'danger' : 'success'
        },
        {
            key: 'TOt',
            condition: (value) => value > 0 ? 'danger' : 'success'
        },
    ];


    return (
        // <p>Page 3 </p>
        devicesInfo
            ? <Table
                data={devicesInfo}
                scrollHeight={'560px'}
                minWidth={'200rem'}
                commonColumsName={['Product']}
                columnsName={['Install ID', 'Serial ID', 'Space Name', 'Marker ID', 'Category', 'Space ID',
                    'Presence', 'Heart Beat', 'Last Frame', 'I2C Error', 'Network', 'Build', 'TOy', 'TOt', 'Risk']}
                frozenCol={['Product', 'Install ID', 'Risk']}
                tagCol={['TOy', 'TOt']}
                tagConditions={tagConditions}
                globalFilterFields={['Product', 'Install ID', 'Space ID','Serial ID']}
                downloadOption={true}
                pagination={false}
                numberOfRows={20}
                rowsPerPageOptions={[25, 50, 100]}
            />
            : <div style={{ height: '100vh', width: '100%', textAlign: 'center' }}>
                Loading...
            </div>
    )
}

export default LocationWiseHealth;